import React, { Component } from 'react';

const DISMISS_KEY = 'wk_theme_help_dismissed';

class ThemeHelpBox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dismissed: this.isDismissedToday(),
        };
    }

    isDismissedToday() {
        try {
            const stored = localStorage.getItem(DISMISS_KEY);
            if (!stored) return false;
            const dismissDate = new Date(stored);
            const today = new Date();
            return dismissDate.toDateString() === today.toDateString();
        } catch (e) {
            return false;
        }
    }

    handleDismiss = () => {
        try {
            localStorage.setItem(DISMISS_KEY, new Date().toISOString());
        } catch (e) { /* ignore */ }
        this.setState({ dismissed: true });
    }

    render() {
        // Hide if dismissed today or if org has custom themes
        if (this.state.dismissed || this.props.hasCustomTheme) return null;

        return (
            <div className="mx-4 mt-3 mb-1 bg-blue-50 border border-blue-200 rounded-lg p-4 relative">
                <button
                    onClick={this.handleDismiss}
                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
                    aria-label="Dismiss"
                >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
                        <line x1="18" y1="6" x2="6" y2="18" />
                        <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                </button>
                <div className="flex items-start space-x-3">
                    <svg className="shrink-0 mt-0.5" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#3b82f6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="3" width="7" height="7" />
                        <rect x="14" y="3" width="7" height="7" />
                        <rect x="3" y="14" width="7" height="7" />
                        <rect x="14" y="14" width="7" height="7" />
                    </svg>
                    <div>
                        <p className="text-sm font-medium text-blue-800">Customize your slide design</p>
                        <p className="text-xs text-blue-600 mt-1">
                            Upload a .protheme file from ProPresenter to match your church's visual style.
                            {' '}<a href="/slides/themes" className="underline font-medium text-blue-800">Go to the Themes tab</a> to get started.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

export default ThemeHelpBox;
